import {
  getRequiredApi,
  getRequiredPageApi,
  getDoneMatchApi,
  getDonePageApi,
  getMatchCountApi,
} from "api/match";

// expert 가 수리할 공개 요청을 가져오거나, 이미 수락한 내 매칭 목록을 가져온다.

export const getAllMatchingList = async (_start, _last) => {
  try {
    return await getRequiredApi();
  } catch (error) {
    console.error("failed getAllMatchingList:", error);
    return [];
  }
};

export const getAllRequestList = async (amount, lastCreateDate, category, region) => {
  try {
    const page = lastCreateDate ? 2 : 1;
    return await getRequiredPageApi({ page, limit: amount || 20, category, region });
  } catch (error) {
    console.error("failed getAllRequestList:", error);
    return [];
  }
};

export const getAllRequestListPrev = async (amount, _lastCreateDate, category, region) => {
  try {
    const list = await getRequiredPageApi({ page: 1, limit: amount || 20, category, region });
    return list.slice().reverse();
  } catch (error) {
    console.error("failed getAllRequestListPrev:", error);
    return [];
  }
};

export const getAllRequestCount = async (category) => {
  try {
    return await getMatchCountApi({ status: "0", field: category ? "selectList" : undefined });
  } catch (error) {
    console.error("failed getAllRequestCount:", error);
    return 0;
  }
};

export const getMyMatchingList = async (id, amount, lastCreateDate, category) => {
  try {
    const page = lastCreateDate ? 2 : 1;
    return await getDonePageApi(id, { page, limit: amount || 20, category });
  } catch (error) {
    console.error("failed getMyMatchingList:", error);
    return [];
  }
};

export const getMyMatchingListPrev = async (id, amount, _lastCreateDate, category) => {
  try {
    const list = await getDonePageApi(id, { page: 1, limit: amount || 20, category });
    return list.slice().reverse();
  } catch (error) {
    console.error("failed getMyMatchingListPrev:", error);
    return [];
  }
};

export const getMyMatchingListCount = async (id, category) => {
  try {
    return await getMatchCountApi({ id, field: category ? "selectList" : undefined });
  } catch (error) {
    console.error("failed getMyMatchingListCount:", error);
    return 0;
  }
};
